<div *ngIf="(showSpinner$ | async)" class="app-Notification">
  <div class="app-Notification__content">
    <mat-progress-spinner mode="indeterminate" [strokeWidth]="5" [diameter]="60" class="app-Notification__spinner">
    </mat-progress-spinner>
    <div class="app-Notification__message">Loading...</div>
  </div>
</div>
